var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionContainer',[_c('section',{staticClass:"content-panel generic-text-panel rich-text-editor",class:'panel-width-' + _vm.data.width,domProps:{"innerHTML":_vm._s(_vm.data.bodyText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }